import { useQuery } from '@tanstack/react-query';
import { reservationApi } from '@/api/reservations';

/**
 * React Query hook to fetch store information
 * Cached for 5 minutes to avoid unnecessary API calls
 */
export function useStoreInfo(storeDomain: string | null) {
  return useQuery({
    queryKey: ['store', storeDomain],
    queryFn: () => {
      if (!storeDomain) {
        throw new Error('Store domain is required');
      }
      return reservationApi.getStoreInfo(storeDomain);
    },
    enabled: !!storeDomain, // Only fetch when domain is available
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 2, // Retry failed requests twice
  });
}
